import { Component, Input } from '@angular/core'
import Performer from '@account/Performer'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { PerformerClassesComponent } from '@account/Components/Performers/Performer/Classes/PerformerClasses.Component'

@Component({
	selector: 'performer-quick-add-component',
	templateUrl: './PerformerQuickAdd.Component.html',
	imports: [CardComponent, CardContentComponent, PerformerClassesComponent],
})
export class PerformerQuickAddComponent {
	@Input() public performer: Performer
}
